import React, { useState, useEffect } from 'react';
import {
  Form,
  Modal,
  FloatingLabel,
  Spinner,
} from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { useAlert } from 'react-alert';
import Cookies from 'js-cookie';
import { TiTick } from 'react-icons/ti';
import './authStyles.css';

const LoginPageNew = () => {
  const history = useHistory();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);
  const alert = useAlert();
  const [passwordModal, setPasswordModal] = useState(false);
  const [forgotUsername, setForgetUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [confirmationCode, setConfirmationCode] = useState('');
  const [resetLoader, setResetLoader] = useState(false);
  const [isPasswordReset, setIsPasswordReset] = useState(true);
  const [modifyPasswordLoader, setModifyPasswordLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showLogin, setShowLogin] = useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
  const [passwordNotMatching, setPasswordNotMatching] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const resetModalState = () => {
    setPasswordModal(false);
    setIsPasswordReset(true);
    setForgetUsername('');
    setNewPassword('');
    setConfirmNewPassword('');
    setConfirmationCode('');
    setErrorMessage('');
    setPasswordErrorMessage('');
    setPasswordNotMatching('');
    setShowLogin(false);
  };

  useEffect(() => {
    try {
      const credentialsString = localStorage.getItem('credentials');
      if (credentialsString) {
        const loginDetails = JSON.parse(credentialsString);
        if (loginDetails) {
          history.push('/');
        }
      }
    } catch (error) {
      // Silently handle malformed JSON - user can still log in
      console.error('Failed to parse stored credentials:', error);
      localStorage.removeItem('credentials'); // Clean up invalid data
    }
  }, [history]);

  const submitHandler = e => {
    e.preventDefault();
    userValidator();
  };

  const userValidator = async () => {
    setLoginLoading(true);
    let dataToSend = {
      username: username,
      password: password,
      // type: 'login',
    };
    var config = {
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL || 'https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing'}/client/login`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: dataToSend,
      validateStatus: function (status) {
        return status >= 200 && status < 300;
      },
    };
    try {
      const axiosData = await axios.request(config);
      const isSuccess = axiosData.data.isSuccess;
      if (isSuccess) {
        const authTokens = axiosData.data.data.authTokens || {};
        const refreshToken = authTokens.refreshToken;
        const idToken = authTokens.idToken;
        const accessToken = authTokens.accessToken;
        setLoginLoading(false);
        const cookieOptions = {
          expires: 1,
          secure: process.env.NODE_ENV === 'production',
          sameSite: 'Strict',
        };
        Cookies.set('refreshToken', refreshToken, cookieOptions);
        Cookies.set('idToken', idToken, cookieOptions);
        Cookies.set('accessToken', accessToken, cookieOptions);
        const userDetails = axiosData.data.data.userDetails || {};
        const endpoints = axiosData.data.data.endpoints || userDetails.endpoints || {};
        // clientData is only present in the admin login response — empty array for regular clients
        const clientData = axiosData.data.data.clientData || [];
        localStorage.setItem(
          'credentials',
          JSON.stringify({ ...userDetails, endpoints, clientData })
        );
        localStorage.setItem('loginTimeStamp', new Date().getTime());
        history.push('/');
        window.location.reload();
      } else {
        const { error } = axiosData.data;
        setLoginLoading(false);
        alert.error(error.message);
      }
    } catch (error) {
      alert.error(error.message);
      setLoginLoading(false);
    }
  };

  const resetPassword = async e => {
    setResetLoader(true);
    e.preventDefault();
    const body = {
      username: forgotUsername,
    };
    const resetPasswordConfig = {
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL || 'https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing'}/client/forgotpassword`,
      data: JSON.stringify(body),
    };
    try {
      const resetPasswordResponse = await axios(resetPasswordConfig);
      const isSuccess = resetPasswordResponse.data.isSuccess || resetPasswordResponse.status === 200;
      if (isSuccess) {
        setIsPasswordReset(false);
      } else {
        alert.error("Failed to send reset code. Please try again.");
      }
    } catch (error) {
      alert.error(error.message || "An error occurred while sending reset code.");
    } finally {
      setResetLoader(false);
    }
  };

  const modifyPassword = async e => {
    e.preventDefault();
    const body = {
      username: forgotUsername,
      password: newPassword,
      confirmation_code: confirmationCode,
    };
    const modifyPasswordConfig = {
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL || 'https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing'}/client/resetpassword`,
      data: JSON.stringify(body),
    };
    if (
      passwordPatternCheck(newPassword) &&
      newPassword.length >= 8 &&
      newPassword === confirmNewPassword
    ) {
      setModifyPasswordLoader(true);
      try {
        const modifyPasswordResponse = await axios(modifyPasswordConfig);
        const isSuccess = modifyPasswordResponse.data.isSuccess;
        if (isSuccess) {
          setShowLogin(true);
        } else {
          const message = modifyPasswordResponse.data.error.message
            ? modifyPasswordResponse.data.error.message
            : modifyPasswordResponse.data.error;
          setErrorMessage(message);
        }
      } catch (error) {
        const message = error.response?.data?.error?.message || error.message || "An error occurred";
        setErrorMessage(message);
      } finally {
        setModifyPasswordLoader(false);
      }
    } else if (newPassword !== confirmNewPassword) {
      setPasswordNotMatching('Passwords not matching');
    } else {
      setPasswordErrorMessage(
        'Password with min 8 characters must contain at least one capital, small, number and special character.'
      );
    }
  };

  const passwordPatternCheck = passwordInput => {
    let specialCharCheck = false;
    let capitalLetterCheck = false;
    let smallLetterCheck = false;
    let numericValueCheck = false;

    capitalLetterCheck = passwordInput
      .split('')
      .some(
        (charcode, index) =>
          passwordInput.charCodeAt(index) >= 65 &&
          passwordInput.charCodeAt(index) <= 90
      );
    smallLetterCheck = passwordInput
      .split('')
      .some(
        (charcode, index) =>
          passwordInput.charCodeAt(index) >= 97 &&
          passwordInput.charCodeAt(index) <= 122
      );
    numericValueCheck = passwordInput
      .split('')
      .some(
        (charcode, index) =>
          passwordInput.charCodeAt(index) >= 48 &&
          passwordInput.charCodeAt(index) <= 57
      );
    specialCharCheck = passwordInput
      .split('')
      .some(
        (charcode, index) =>
          (passwordInput.charCodeAt(index) >= 91 &&
            passwordInput.charCodeAt(index) <= 96) ||
          (passwordInput.charCodeAt(index) >= 58 &&
            passwordInput.charCodeAt(index) <= 64) ||
          (passwordInput.charCodeAt(index) >= 33 &&
            passwordInput.charCodeAt(index) <= 47) ||
          (passwordInput.charCodeAt(index) >= 123 &&
            passwordInput.charCodeAt(index) <= 126)
      );

    return (
      numericValueCheck &&
      capitalLetterCheck &&
      smallLetterCheck &&
      specialCharCheck
    );
  };

  return (
    <div className='auth-container'>
      <div className='auth-bg-circle circle-1'></div>
      <div className='auth-bg-circle circle-2'></div>

      <div className='auth-wrapper'>
        {/* Left Visual Side */}
        <div className='auth-visual'>
          <img
            src='https://niroggyan.s3.ap-south-1.amazonaws.com/pdftosrportal/loginLandingImage.svg'
            alt='Niroggyan Dashboard'
          />
          <div className='auth-visual-text'>
            <h3>Smart Report Portal</h3>
            <p>Manage your lab reports, analytics, and patient data in one seamless platform.</p>
          </div>
        </div>

        {/* Right Form Side */}
        <div className='auth-form-container'>
          <button
            type="button"
            onClick={() => history.push('/')}
            className="auth-logo-button"
            aria-label="Go to home page"
          >
            <img
              src='https://niroggyan.s3.ap-south-1.amazonaws.com/new-billing-dashboard-files/logos/niroggyan-logo.svg'
              alt="Niroggyan"
              className="auth-logo"
            />
          </button>

          <div className='auth-header'>
            <h2 className='auth-title'>Welcome Back</h2>
            <p className='auth-subtitle'>Please enter your details to sign in.</p>
          </div>

          <Form id='login' onSubmit={submitHandler} className='auth-form'>
            <FloatingLabel controlId='username' label='Username' className='mb-3'>
              <Form.Control
                required
                type='text'
                placeholder='Enter username'
                value={username}
                onChange={e => setUsername(e.target.value)}
              />
            </FloatingLabel>

            <FloatingLabel controlId='password' label='Password' className='mb-3'>
              <Form.Control
                required
                type={showPassword ? 'text' : 'password'}
                placeholder='Enter your password'
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </FloatingLabel>

            <div className='d-flex justify-content-between align-items-center mb-4'>
              <Form.Check
                type="checkbox"
                id="show-password"
                label="Show Password"
                className="small text-muted"
                onChange={e => setShowPassword(e.target.checked)}
              />
              <button
                type="button"
                className='auth-link small'
                onClick={() => setPasswordModal(true)}
              >
                Forgot Password?
              </button>
            </div>

            <button
              type='submit'
              className='auth-btn'
              disabled={loginLoading}
            >
              {loginLoading ? (
                <>Signing In <Spinner size="sm" animation="border" /></>
              ) : (
                'Sign In'
              )}
            </button>
          </Form>

          <div className='auth-footer'>
            Don't have an account?{' '}
            <button
              className='auth-link'
              onClick={() => history.push('/signup')}
            >
              Sign up
            </button>
          </div>
        </div>
      </div>

      {/* Forgot Password Modal */}
      <Modal
        show={passwordModal}
        onHide={resetModalState} animation={true}
        centered
        backdrop='static'
        dialogClassName='modal-dialog-centered'
        contentClassName='auth-modal-content'
      >
        <Modal.Header closeButton className='auth-modal-header border-0 pb-0'>
          <Modal.Title className='auth-title fs-4 auth-modal-title'>
            {isPasswordReset ? 'Reset Password' : 'Change Password'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='auth-modal-body pt-0 pb-4 px-4'>
          {isPasswordReset ? (
            <Form
              id='forget-password'
              onSubmit={resetPassword}
              className='mt-3'
            >
              <p className='text-muted small mb-3'>Enter your username to receive a reset code.</p>
              <FloatingLabel
                controlId='reset-username'
                label='Username'
                className='mb-3'
              >
                <Form.Control
                  onChange={e => setForgetUsername(e.target.value)}
                  required
                  type='text'
                  placeholder='Username'
                  value={forgotUsername}
                />
              </FloatingLabel>
              <button
                disabled={resetLoader}
                type='submit'
                className='auth-btn mt-2'
              >
                {resetLoader ? <Spinner size="sm" /> : 'Send Reset Code'}
              </button>
            </Form>
          ) : (
            <Form
              id='new-password'
              onSubmit={modifyPassword}
              autoComplete='off'
              className='mt-3'
            >
              <FloatingLabel controlId='new-pass' label='New Password' className='mb-3'>
                <Form.Control
                  onChange={e => {
                    setNewPassword(e.target.value);
                    setPasswordErrorMessage('');
                  }}
                  required
                  type='password'
                  placeholder='New Password'
                  value={newPassword}
                />
              </FloatingLabel>
              {passwordErrorMessage && <p className='text-danger small'>* {passwordErrorMessage}</p>}

              <FloatingLabel controlId='confirm-pass' label='Confirm Password' className='mb-3'>
                <Form.Control
                  onChange={e => {
                    setConfirmNewPassword(e.target.value);
                    setPasswordNotMatching('');
                  }}
                  required
                  type='password'
                  placeholder='Confirm Password'
                  value={confirmNewPassword}
                />
              </FloatingLabel>
              {passwordNotMatching && <p className='text-danger small'>* {passwordNotMatching}</p>}

              <FloatingLabel controlId='conf-code' label='Confirmation Code' className='mb-3'>
                <Form.Control
                  onChange={e => {
                    setConfirmationCode(e.target.value);
                    setErrorMessage('');
                  }}
                  required
                  type='text'
                  placeholder='Code'
                  value={confirmationCode}
                />
              </FloatingLabel>

              {errorMessage && <p className='text-danger small'>* {errorMessage}</p>}

              {!showLogin ? (
                <button
                  type='submit'
                  disabled={modifyPasswordLoader}
                  className='auth-btn mt-2'
                >
                  {modifyPasswordLoader ? <Spinner size="sm" /> : 'Set New Password'}
                </button>
              ) : (
                <div className='text-center'>
                  <p className='text-success mb-3'>
                    <TiTick size={22} /> Password updated successfully!
                  </p>
                  <button
                    type="button"
                    onClick={() => {
                      resetModalState();
                    }}
                    className='auth-btn'
                  >
                    Return to Login
                  </button>
                </div>
              )}
            </Form>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default LoginPageNew;
